import { convertSnakeCaseToCamelCaseNative } from '../../web-components/utils/formatterResponseNative'
import { encodeSHA256 } from '../../core-apis/src/apis/config/utils'

const AUTH_KEY_SECRET = process.env.AUTH_KEY_SECRET

export const fetchServerXBasicAuthNative = async (
    url: string,
    options?: RequestInit
  ) => {
    const timestamp = Date.now()
    const token = encodeSHA256(timestamp, AUTH_KEY_SECRET as string)
  
    const headers = {
      ...options?.headers,
      timestamp: `${timestamp}`,
      Authorization: `${token}`
    }
    const res = await fetch(url, {
      ...options,
      headers
    })
  
    const data = await res?.json()
  
    return {
      data: data ? convertSnakeCaseToCamelCaseNative(data) : res,
      status: res?.status,
      isError: !res?.ok
    }
  }